<script setup lang="ts">
defineOptions({
  inheritAttrs: false,
});

const ERROR_IMG_SRC =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODgiIGhlaWdodD0iODgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBvcGFjaXR5PSIuMyIgZmlsbD0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIzLjciPjxyZWN0IHg9IjE2IiB5PSIxNiIgd2lkdGg9IjU2IiBoZWlnaHQ9IjU2IiByeD0iNiIvPjxwYXRoIGQ9Im0xNiA1OCAxNi0xOCAzMiAzMiIvPjxjaXJjbGUgY3g9IjUzIiBjeT0iMzUiIHI9IjciLz48L3N2Zz4KCg==';

withDefaults(
  defineProps<{
    src?: string;
    alt?: string;
  }>(),
  {
    src: '',
    alt: '',
  },
);

const didError = ref(false);

const handleError = () => {
  didError.value = true;
};
</script>

<template>
  <div
    v-if="didError"
    class="ai-image-fallback"
    :class="$attrs.class as any"
    :style="$attrs.style as any"
  >
    <div class="ai-image-fallback__inner">
      <img
        :src="ERROR_IMG_SRC"
        alt="Error loading image"
        class="ai-image-fallback__icon"
        :data-original-url="src"
      />
    </div>
  </div>

  <img
    v-else
    :src
    :alt
    :class="$attrs.class as any"
    :style="$attrs.style as any"
    @error="handleError"
  />
</template>

<style scoped>
.ai-image-fallback {
  display: inline-block;
  background: #f3f4f6;
  color: #6b7280;
  text-align: center;
  vertical-align: middle;
}

.ai-image-fallback__inner {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
}

.ai-image-fallback__icon {
  display: block;
  width: 44px;
  height: 44px;
  opacity: 0.75;
}
</style>
